module.exports = __webpack_public_path__ + "static/media/subnav-enterprise.939032f4.svg";